<template>
  <m-scrollbar :key="this.open">
  <div class="sports-menu">
    <div class="default-sports-menu">
      <div id="sport" class="sport" :class="{ open: open && openedSport === sport.id }" v-for="sport in sports" :key="sport.id">
        <div class="sport-hat">
        <active-button
          class="sport-button"
          line-color="blue"
          line-position="left"
          :active="!isActive('view', 'main') && $route.params.sport == sport.id"
          @click="open = !open"
        >
          <sport-icon-liga-white :name="sport.alias"></sport-icon-liga-white>
          <div class="sport-name ellipsis">{{ sport.name }}</div>
        </active-button>
        <icon-button @click="open = !open; openedSport = sport.id">
          <arrow-icon :direction="open && openedSport === sport.id ? 'up' : 'down'"></arrow-icon>
        </icon-button>
        <div class="events-count">{{ sport.events.length }}</div>
      </div>
      <div class="list" v-if="sport.id === openedSport">
        <div class="event" v-for="event in sport.events"
          :key="event.id">
          <div class="score-board-table">
            <div class="score-board-table-head">
              <div class="comment">
                <span class="kind-name" v-if="event.kind">{{ event.kind }}</span>
                {{ event.results.minute ? event.results.minute : '' }}
                <span class="time-blink" v-if="event.results.minute">'</span>
                {{ event.results.comment }}
              </div>
              <div class="right-flex" v-if="event.results.score" style="margin-right: 10px;">
                <div class="common-score score-cell">{{ $t('live.score') }}</div>
                <div class="flex" v-if="event.results.score.periods">
                  <div class="score-cell" v-for="(p, i) in event.results.score.periods" :key="i">{{ i + 1 }}</div>
                </div>
                <div class="score-cell" v-if="event.results.score.yellowCards" :title="$t('live.yellow-cards')">
                  <sport-icon medium name="yellow-card" />
                </div>
                <div class="score-cell" v-if="event.results.score.corners" :title="$t('live.corners')">
                  <sport-icon medium name="corner" />
                </div>
              </div>
            </div>
            <div class="score-board-table-team">
              <div class="team-name">{{ event.home }}</div>
              <div class="right-flex" v-if="event.results.score" style="margin-right: 10px;">
                <div class="common-score score-cell">{{ event.results.score.home }}</div>
                <div class="flex" v-if="event.results.score.periods">
                  <div class="score-cell" v-for="(p, i) in event.results.score.periods" :key="i">{{ p.home }}</div>
                </div>
                <div class="score-cell" v-if="event.results.score.yellowCards">{{ event.results.score.yellowCards.home }}</div>
                <div class="score-cell" v-if="event.results.score.corners">{{ event.results.score.corners.home }}</div>
                <div class="game-score score-cell" v-if="event.results.points">{{ event.results.points.home }}</div>
                <div class="turn-cell" v-if="event.results.turn && event.results.turn === 1">
                  <sport-icon medium :name="sport.alias" />
                </div>
              </div>
            </div>
            <div class="score-board-table-team">
              <div class="team-name">{{ event.away }}</div>
              <div class="right-flex" v-if="event.results.score" style="margin-right: 10px;">
                <div class="common-score score-cell">{{ event.results.score.away }}</div>
                <div class="flex" v-if="event.results.score.periods">
                  <div class="score-cell" v-for="(p, i) in event.results.score.periods" :key="i">{{ p.away }}</div>
                </div>
                <div class="score-cell" v-if="event.results.score.yellowCards">{{ event.results.score.yellowCards.away }}</div>
                <div class="score-cell" v-if="event.results.score.corners">{{ event.results.score.corners.away }}</div>
                <div class="game-score score-cell" v-if="event.results.points">{{ event.results.points.away }}</div>
                <div class="turn-cell" v-if="event.results.turn && event.results.turn === 2">
                  <sport-icon medium :name="sport.alias" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <!--sport
        v-for="sport in sports"
        :key="sport.id"
        :sport="sport"
      >
        <event
          class="event"
          v-for="event in sport.events"
          :key="event.id"
          :event="event"
          :sport="sport.alias"
          @click="$router.push(`/live/sport/${sport.id}/event/${event.id}`)"
        ></event>
      </sport-->
    </div>
    <!--div class="compact-sports-menu">
      <active-button
        v-for="sport in sports"
        :key="sport.id"
        :active="!isActive('view', 'main') && $route.params.sport == sport.id"
        :title="sport.name"
        line-color="blue"
        line-position="left"
        @click="$router.push(`/live/sport/${sport.id}`)"
      >
        <sport-icon-liga :name="sport.alias"></sport-icon-liga>
      </active-button>
    </div-->
  </div>
  </m-scrollbar>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import IconButton from '@/components/buttons/IconButton'
import SportIcon from '@/components/icons/SportIcon'
import Sport from '@/components/results/live/menu/Sport'
import Event from '@/components/results/live/menu/Event'
import ArrowIcon from '@/components/icons/ArrowIcon'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import MScrollbar from '@/components/MScrollbar'
import { routeProp } from '@/mixins/routeProp'
import { mapState } from 'vuex'

export default {
  mixins: [ routeProp ],
  components: {
    ActiveButton,
    IconButton,
    SportIcon,
    Sport,
    Event,
    MScrollbar,
    ArrowIcon,
    SportIconLigaWhite
  },
  computed: {
    ...mapState({
      sports: state => state.live.menu
    })
  },
  data () {
    return {
      updateInterval: null,
      open: false,
      openedSport: null
    }
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('live/GET_MENU_SPORTS')
    }
  },
  mounted () {
    const dispatchGetting = () => {
      this.$store.dispatch('live/GET_MENU_SPORTS')
    }
    dispatchGetting()
    this.updateInterval = setInterval(function () {
      dispatchGetting()
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
  }
}
</script>

<style scoped>
.default-sports-menu { width: 240px; }
.all-sports-button { display: flex; }
.all-sports-button .sport-icon { margin: 12px; }
.all-sports-button-label { height: 40px; line-height: 40px; padding-right: 10px; width: 160px; }
.event:not(:first-child) { border-top: 1px solid rgba(255, 255, 255, .1); }

.compact-sports-menu { display: none; }
.compact-sports-menu .active-button { height: 40px; }
.compact-sports-menu .sport-icon { margin: 12px; }

.sport-hat {
  display: flex;
  border-radius: 10px;
  background: white;
  margin-left: 5px;
  margin-right: 10px;
  margin-bottom: 4px;
}
.sport-hat:hover { background: #d4dbe3; }
.sport-hat.active:first-child { border: 1px solid #713592; margin-bottom: 3px; }
.sport-hat.active { border: 1px solid #713592; margin-bottom: 3px; margin-top: -1px;}
.sport-button { display: flex; height: 40px; line-height: 40px; width: 185px;}
.sport-icon-liga-white { margin-left: 10px; margin-top: 8px; }
.sport-name { flex: 1; padding-right: 10px; margin-left: 10px; }
.events-count { flex-shrink: 0; height: 40px; line-height: 40px; text-align: center; width: 40px; margin-right: -0.80px; }
.list { background: rgba(255, 255, 255, .05); display: none; position: relative; }
.open .list { display: block; margin-left: 5px; width: 225px; }
.activeSport { margin-left: 9.20px; }

.sport .icon-button,
.sport:hover .events-count,
.sport.open .events-count { display: none; }
.sport:hover .icon-button,
.sport.open .icon-button { display: flex; }

.event { overflow: hidden; position: relative; margin-bottom: 4px; }
.event-hat { align-items: center; display: flex; min-height: 40px; }
.event-time { flex-shrink: 0; text-align: center; width: 80px; }
.event-name { flex: 1; }
.event-result { width: 40%; }
.event-extra { border-top: 1px solid #007354; display: none; margin-left: 10px; padding: 10px 10px 10px 0; }
.event-extra p:not(:first-child) { margin-top: 5px; }
.event-extra b { color: #007354; font-weight: normal; }
.open.event .event-extra { display: block; }
.white { color: white !important; }

.match-layout { /* margin: 0 10px; */ margin-right: 10px; background: white; }
.score-board-table { position: relative; margin-top: 5px; margin-bottom: 5px; }
.score-board-table-head { border-bottom: 1px solid rgba(255, 255, 255, .07); display: flex; height: 24px; line-height: 24px; margin-bottom: 4px; }
.score-board-table-head .comment { color: rgb(113, 53, 146); margin-left: 10px; }
.score-board-table-head .kind-name { color: #ffa726; margin-right: 5px; }
.score-board-table-team { display: flex; height: 23px; font-size: 13px; line-height: 23px; margin-left: 10px; }
.score-cell { text-align: center; width: 34px; color: white; }
.common-score { color: darrkorange; }
.common-score.score-cell { color: darkorange;}
.game-score { color: darkorange; }
.turn-cell { width: 12px; }
.pause { width: 100%; text-align: center; height: 50px; line-height: 50px; font-size: 14pt; }

</style>

<style>
.left-sidebar-layout.compact .default-sports-menu { display: none; }
.left-sidebar-layout.compact .compact-sports-menu { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/results/live/menu/Menu.vue